module.exports = __webpack_public_path__ + "fonts/MTkjk4.8b73bd49.ttf";